import React, { forwardRef } from 'react'

import { DatePicker } from 'antd'

import type { ForwardRefRenderFunction } from 'react'
import type { Dayjs } from 'dayjs'
import type { DatePickRef } from 'antd/es/date-picker/generatePicker/interface'
import type { LntDatePickerProps } from './types'

const Component: ForwardRefRenderFunction<DatePickRef<Dayjs>, LntDatePickerProps> = (props, ref) => {
  return (
    <DatePicker
      { ...props }
      ref={ ref as DatePickRef<Dayjs> }
    />
  )
}

export const LntDatePicker = forwardRef<DatePickRef<Dayjs>, LntDatePickerProps>(Component)
